export const InformativeTag = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="inline-flex text-sm tracking-[0.2em] text-orange-700 font-medium uppercase bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full border-orange-200">
      {children}
    </div>
  );
};
